import React from "react";
import { compose } from "redux";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const ColumnDescription = ({ classes, children }) => (
  <Typography noWrap className={classes.columnDescription}>
    {children}
  </Typography>
);

const styles = theme => ({
  columnDescription: {
    height: "100%",
    padding: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
  },
});

export default compose(withStyles(styles))(ColumnDescription);
